<template>
  <section id="next-events">
    <div class="widget-wrap">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h1 class="section-title title-merienda">
              Próximas Funciones!
            </h1>
          </div>
        </div>
        <div class="row funciones-row">
          <div
            v-for="show in proximasFunciones"
            :key="show.id"
            class="funcion-col"
          >
            <figure class="image-thumb">
              <router-link :to="show.link" class="funcion-link">
                <img width="300" height="300" :src="show.imagen" :alt="show.titulo" class="next-sesion">
              </router-link>
            </figure>
          </div>
        </div>
        <!-- Ver toda la cartelera button -->
        <div class="row">
          <div class="col-xs-12 cartelera-btn-wrap">
            <router-link to="/cartelera" class="cartelera-btn">
              Ver toda la cartelera
              <span class="btn-arrow">→</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Grupo Babilonia Parallax Section -->
  <section class="parallax-section">
    <div class="parallax-bg" :style="{ backgroundImage: `url('/images/Babilonia_Landing_Page_1.JPG')` }"></div>
    <div class="parallax-overlay"></div>
    <div class="parallax-content">
      <h2 class="parallax-title">Grupo Babilonia</h2>
      <p class="parallax-text">
        Hace 30 años llevando el teatro a las calles y escenarios de Uruguay.
        Conocé nuestra historia, nuestros integrantes y nuestra pasión por el arte.
      </p>
      <router-link to="/el-grupo" class="parallax-btn">Más</router-link>
    </div>
  </section>

  <!-- Galeria de Fotos Section -->
  <section class="galeria-section">
    <div class="container">
      <h2 class="section-title">Galeria de Fotos</h2>
      <div class="galeria-panel">
        <img src="/images/Babilonia_Landing_Page_2.JPG" alt="Galeria Grupo Babilonia" class="galeria-img">
        <div class="galeria-overlay">
          <router-link to="/galeria" class="galeria-btn">Ver más</router-link>
        </div>
      </div>
    </div>
  </section>

  <!-- Newsletter Subscription Section (Coming Soon) -->
  <section class="newsletter-section">
    <div class="container">
      <h3 class="newsletter-title">
        Para recibir informaciones sobre el Grupo y de los próximos espectáculos:
      </h3>
      <form class="newsletter-form" @submit.prevent>
        <input
          type="email"
          placeholder="Tu correo electrónico"
          class="newsletter-input disabled"
          readonly
          @click="showComingSoon"
        >
        <button type="button" class="newsletter-btn disabled" @click="showComingSoon">Inscribir</button>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      alertShown: false,
      funciones: [
        {
          id: 4,
          titulo: 'Ernesto Díaz & Fabián Severo',
          imagen: '/images/prox_func/Ernesto_Diaz.jpg',
          link: '/funcion/4',
          date: '2026-02-13'
        },
        {
          id: 1,
          titulo: 'El Quijote Popular',
          imagen: '/images/prox_func/Quijote.jpg',
          link: '/funcion/1',
          date: '2026-02-14'
        },
        {
          id: 2,
          titulo: '8 Espejos',
          imagen: '/images/prox_func/8_Espejos.jpeg',
          link: '/funcion/2',
          date: '2026-02-20'
        },
        {
          id: 3,
          titulo: 'La Loca del Bequeló',
          imagen: '/images/prox_func/La_loca_del_Bequelo.jpg',
          link: '/funcion/3',
          date: '2026-02-21'
        },
        {
          id: 5,
          titulo: 'Buceo Invisible',
          imagen: '/images/prox_func/Buceo_Invisible.jpeg',
          link: '/funcion/5',
          date: '2026-02-27'
        },
        {
          id: 6,
          titulo: 'Noche de Circo',
          imagen: '/images/prox_func/Donde_estoy.jpeg',
          link: '/funcion/6',
          date: '2026-02-28'
        },
        {
          id: 7,
          titulo: 'Noche de Circo',
          imagen: '/images/prox_func/la_silueta_del_circo.jpeg',
          link: '/funcion/6',
          date: '2026-02-28'
        },
        {
          id: 7,
          titulo: 'Tercer Fuerxa',
          imagen: '/images/prox_func/tercer_fuerxa.jpeg',
          link: '/funcion/7',
          date: '2026-03-06'
        },
        {
          id: 8,
          titulo: 'Por culpa de la E',
          imagen: '/images/prox_func/por_culpa_de_la_e.jpeg',
          link: '/funcion/8',
          date: '2026-03-07'
        },
        {
          id: 9,
          titulo: 'Naipe Marcado Trío Tango',
          imagen: '/images/prox_func/naipe_marcado.jpeg',
          link: '/funcion/9',
          date: '2026-03-08'
        }
      ]
    }
  },
  computed: {
    proximasFunciones() {
      return this.funciones
        .filter(show => !this.isPast(show.date))
        .slice(0, 3)
    }
  },
  methods: {
    isPast(dateStr) {
      const showDate = new Date(dateStr + 'T23:59:59')
      const today = new Date()
      return showDate < today
    },
    showComingSoon(event) {
      if (this.alertShown) return;
      this.alertShown = true;
      event.target.blur();
      alert('¡Esta funcionalidad aún no está lista! En breve la habilitaremos.');
      setTimeout(() => {
        this.alertShown = false;
      }, 500);
    }
  }
};
</script>

<style scoped>
/* ===== Proximas Funciones Title ===== */
.title-merienda {
  font-family: 'Merienda', cursive !important;
  font-weight: 700 !important;
  font-size: 64px !important;
  text-transform: none !important;
  text-align: center !important;
}

@media (max-width: 767px) {
  .title-merienda {
    font-size: 44px !important;
  }
}

/* ===== Proximas Funciones Links ===== */
.funciones-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  margin-left: 0;
  margin-right: 0;
}

.funcion-col {
  flex: 0 0 auto;
  width: 300px;
  text-align: center;
}

@media (max-width: 767px) {
  .funciones-row {
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
  .funcion-col {
    width: 80vw;
    max-width: 300px;
  }
}

.funcion-link {
  display: block;
  transition: transform 0.3s ease;
}

.funcion-link:hover {
  transform: scale(1.05);
}

.funcion-link .next-sesion {
  transition: box-shadow 0.3s ease;
}

.funcion-link:hover .next-sesion {
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
}

/* ===== Cartelera Button ===== */
.cartelera-btn-wrap {
  text-align: center;
  margin-top: 40px;
}

.cartelera-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: transparent;
  color: #c9a227;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 15px 35px;
  border: 2px solid #c9a227;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  transition: all 0.3s ease;
}

.cartelera-btn:hover {
  background: #c9a227;
  color: #000;
  transform: scale(1.05);
}

.btn-arrow {
  font-size: 20px;
  transition: transform 0.3s ease;
}

.cartelera-btn:hover .btn-arrow {
  transform: translateX(5px);
}

/* ===== Parallax Section ===== */
.parallax-section {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.parallax-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150%;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  z-index: 1;
}

.parallax-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2;
}

.parallax-content {
  position: relative;
  z-index: 3;
  text-align: center;
  padding: 40px 20px;
  max-width: 800px;
}

.parallax-title {
  font-size: 48px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 20px;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
}

.parallax-text {
  font-size: 18px;
  color: #fff;
  line-height: 1.6;
  margin-bottom: 30px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.7);
}

.parallax-btn {
  display: inline-block;
  padding: 15px 50px;
  background: red;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  border: 2px solid red;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.parallax-btn:hover {
  background: transparent;
  color: red;
  border-color: red;
}

/* ===== Mobile - No parallax effect ===== */
@media (max-width: 992px) {
  .parallax-section {
    height: 350px;
  }

  .parallax-bg {
    background-attachment: scroll; /* Disable parallax on mobile */
    height: 100%;
  }

  .parallax-title {
    font-size: 32px;
  }

  .parallax-text {
    font-size: 16px;
    padding: 0 20px;
  }

  .parallax-btn {
    padding: 12px 40px;
    font-size: 16px;
  }
}

/* ===== Galeria de Fotos Section ===== */
.galeria-section {
  background: #000;
  padding: 60px 0;
}

.galeria-section .section-title {
  text-align: center;
  margin-bottom: 40px;
}

.galeria-panel {
  position: relative;
  width: 100%;
  max-width: 1140px;
  height: 240px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 10px;
}

.galeria-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.galeria-panel:hover .galeria-img {
  transform: scale(1.05);
}

.galeria-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.galeria-panel:hover .galeria-overlay {
  background: rgba(0, 0, 0, 0.6);
}

.galeria-btn {
  display: inline-block;
  padding: 15px 50px;
  background: red;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  text-decoration: none;
  border: 2px solid red;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.galeria-btn:hover {
  background: transparent;
  color: red;
  border-color: red;
}

/* ===== Mobile Galeria ===== */
@media (max-width: 992px) {
  .galeria-section {
    padding: 40px 15px;
  }

  .galeria-panel {
    height: 180px;
  }

  .galeria-btn {
    padding: 12px 40px;
    font-size: 16px;
  }
}

/* ===== Newsletter Section ===== */
.newsletter-section {
  background: #1a1a1a;
  padding: 60px 0;
  border-top: 1px solid #333;
  border-bottom: 1px solid #333;
}

.newsletter-title {
  color: #fff;
  font-size: 24px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.4;
}

.newsletter-form {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  max-width: 600px;
  margin: 0 auto;
}

.newsletter-input {
  flex: 1;
  padding: 15px 20px;
  font-size: 16px;
  border: 2px solid #444;
  border-radius: 5px;
  background: #000;
  color: #fff;
  outline: none;
  transition: border-color 0.3s ease;
}

.newsletter-input::placeholder {
  color: #888;
}

.newsletter-input:focus {
  border-color: red;
}

.newsletter-btn {
  padding: 15px 40px;
  background: red;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  border: 2px solid red;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.newsletter-btn:hover {
  background: transparent;
  color: red;
}

/* Disabled state */
.newsletter-input.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.newsletter-btn.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.newsletter-btn.disabled:hover {
  background: red;
  color: #fff;
}

/* ===== Mobile Newsletter ===== */
@media (max-width: 992px) {
  .newsletter-section {
    padding: 40px 20px;
  }

  .newsletter-title {
    font-size: 18px;
  }

  .newsletter-form {
    flex-direction: column;
    gap: 15px;
  }

  .newsletter-input {
    width: 100%;
  }

  .newsletter-btn {
    width: 100%;
    padding: 15px 30px;
  }
}
</style>